module.exports = __webpack_public_path__ + "img/airplane-5.9f9b266b.jpg";